import { render, staticRenderFns } from "./InspectorDetail.vue?vue&type=template&id=53baeaaf&scoped=true&"
import script from "./InspectorDetail.vue?vue&type=script&lang=ts&"
export * from "./InspectorDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InspectorDetail.vue?vue&type=style&index=0&id=53baeaaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53baeaaf",
  null
  
)

export default component.exports